<div class="main-content-wrapper" data-testid="main-content-wrapper">
  <div class="row" style="margin: 0 0.8rem" data-testid="header-row">
    <div class="col-sm-6 align-items-center" data-testid="header-left">
      <h5 class="mb-0" data-testid="entry-title">
        {{ "Entry"  }} - {{ this.abd || this.originalDeptName }} |
        {{ this.ctg || this.originalCtgName }}
        <span *ngIf="subCategoryID > 0" data-testid="entry-subcategory">
          | {{ this.originalsubCtgName }}</span>
      </h5>
    </div>
    <div class="col-sm-6 align-items-center" data-testid="header-right">
      <div class="d-flex justify-content-end" data-testid="header-switches">

        <ng-template [ngxPermissionsOnly]="['Item:KeepSelection']">
          <div class="reprint-mode d-flex justify-content-end align-items-center pe-4"
            data-testid="keep-selection-switch">
            <h5 class="mb-0 notranslate me-2" data-testid="keep-selection-label">
              {{ "Keep Selection" | translate }}
            </h5>
            <div class="form-check form-switch" data-testid="keep-selection-form">
              <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked1" [checked]="keepSelection"
                (change)="keepChanges()" data-testid="keep-selection-checkbox" />
            </div>
          </div>
        </ng-template>
        <div class="reprint-mode d-flex justify-content-end align-items-center" data-testid="stay-screen-switch">
          <h5 class="mb-0 me-2 notranslate" data-testid="stay-screen-label">
            {{ "Stay Screen" | translate }}
          </h5>
          <div class="form-check form-switch" data-testid="stay-screen-form">
            <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked1" [checked]="isStayScreen"
              (change)="stayScreen()" data-testid="stay-screen-checkbox" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" data-testid="main-row">
    <div class="col-md-4" data-testid="quantity-col">
      <div class="box-content" data-testid="quantity-box">
        <h5 data-testid="quantity-title">{{ "Quantity" | translate }}</h5>
        <div class="d-flex my-3" data-testid="quantity-inputs">
          <div class="enter me-3" data-testid="quantity-input-wrapper">
            <label for="quantityInput" class="form-label ps-0" data-testid="quantity-label">{{ "Quantity" | translate
              }}</label>
            <input type="text" class="form-control" id="quantityInput" name="quantity"
              (input)="validatePositive($event)" [(ngModel)]="quantity" data-testid="quantity-input" />
          </div>
          <div class="enter ms-1" data-testid="piece-input-wrapper">
            <label for="pieceInput" class="form-label ps-0" data-testid="piece-label">{{ "Piece" | translate }}</label>
            <input type="text" class="form-control" id="pieceInput" name="piece" (input)="validatePositive($event)"
              [(ngModel)]="piece" data-testid="piece-input" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 print-box" data-testid="print-box-col">
      <div class="box-content scroller" data-testid="print-box">
        <div class="d-flex justify-content-between" data-testid="print-box-header">
          <h5 class="sticky-top mb-0 notranslate" data-testid="print-format-title">
            {{ "Print_Format" | translate }}
          </h5>
          <div class="d-flex" style="gap: 10px" *ngIf="isPrintPreview" data-testid="print-preview-switch">
            <h5 class="mb-0 notranslate" data-testid="print-preview-label">
              {{ "Print Preview:" | translate }}
            </h5>
            <div class="form-check form-switch" style="margin-top: 1.2rem" data-testid="print-preview-form">
              <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked" [(ngModel)]="PrintMode"
                (ngModelChange)="togglePreview($event)" data-testid="print-preview-checkbox" />
            </div>
          </div>
        </div>
        <div class="row align-items-center" data-testid="print-format-row">
          <div class="col-md-6" *ngFor="let label of formatLabels" data-testid="print-format-label-col">
            <div class="print-label" [class.active]="label.id == activeTag"
              (click)="activeFormatTag(label.id)" data-testid="print-format-label">
              <p data-testid="print-format-label-text">
                {{ label.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template [ngxPermissionsOnly]="['Pricing:ViewAIPricing']">
      <div class="col-md-4" data-testid="ai-pricing-col">
        <div class="box-content" data-testid="ai-pricing-box">
          <h5 data-testid="ai-pricing-title notranslate">
            {{ "AI Pricing Assistant" | translate }}
          </h5>
          <div class="brand-input my-3" data-testid="ai-pricing-input">
            <div class="dropdown" id="selectField" data-testid="ai-pricing-dropdown">
              <a class="btn dropdown-toggle" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown"
                aria-expanded="false" (click)="emptySearchBox()" data-testid="ai-pricing-dropdown-toggle">
                {{ selectedBrandName }}
              </a>
              <div class="dropdown-menu mt-1 pt-0" aria-labelledby="dropdownMenuLink"
                data-testid="ai-pricing-dropdown-menu">
                <div class="searchbar sticky-top px-0 pt-3 mb-2" data-testid="ai-pricing-searchbar">
                  <img class="search me-2" src="../../../assets/icons/searchbar.svg"
                    data-testid="ai-pricing-search-icon" />
                  <input type="text" placeholder="Search" [(ngModel)]="brandSearch" (keyup)="getSearchResult($event)"
                    data-testid="ai-pricing-search-input" />
                </div>
                <ul class="ps-0" data-testid="ai-pricing-brand-list">
                  <li data-testid="ai-pricing-brand-none">
                    <span class="dropdown-item px-0" (click)="selectBrand('None', null)">
                      None</span>
                  </li>
                  <li *ngFor="let brand of brands" data-testid="ai-pricing-brand-item">
                    <span class="dropdown-item px-0" (click)="selectBrand(brand.brandDescr, brand.brandId)"
                      data-testid="ai-pricing-brand-name">{{ brand.brandDescr }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template [ngxPermissionsExcept]="['Pricing:ViewAIPricing']">
      <div class="col-md-4" id="disabledPricing" data-testid="ai-pricing-disabled-col">
        <div class="box-content" data-testid="ai-pricing-disabled-box">
          <h5 data-testid="ai-pricing-disabled-title">
            {{ "AI Pricing Assistant" | translate }}
          </h5>
          <div class="brand-input my-3" data-testid="ai-pricing-disabled-input">
            <div class="dropdown" id="selectField" data-testid="ai-pricing-disabled-dropdown">
              <div class="w-100 d-flex justify-content-between align-items-center border rounded p-2"
                data-testid="ai-pricing-disabled-dropdown-content">
                <span data-testid="ai-pricing-disabled-dropdown-label">
                  Select Brand
                </span>
                <img src="../../../../assets/pos/Group.svg" data-testid="ai-pricing-disabled-dropdown-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  <div class="row" data-testid="secondary-row">
    <div class="col-md-4 second-label" *ngIf="hideSizeGried" data-testid="size-col">
      <div class="box-content scroller" data-testid="size-box">
        <div class="sticky-top header" data-testid="size-header">
          <h5 class="mb-0" data-testid="size-title">
            {{ "Size" | translate }}
          </h5>
          <a data-bs-target="#viewSizesModal" data-bs-toggle="modal" [hidden]="showMoreSizes"
            data-testid="view-all-sizes-link">View All</a>
        </div>
        <div class="row btns-wrapper" data-testid="size-btns-row">
          <div class="col-xl-4 col-lg-6" *ngFor="let button of sizeButtons; let i = index" data-testid="size-btn-col">
            <div class="btn-col-content" data-testid="size-btn-content">
              <button class="btn" [class.active]="button.sizeId === activeButtonIndex" id="sizeBtn"
                (click)="activeSizeButton(button.sizeId, button.alphaSize, i)" data-testid="size-btn">
                {{ button.alphaSize }}<br />
                <span class="ansize" data-testid="size-btn-range">
                  {{ button.numericSizeRange }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 second-label" *ngIf="hideconditionGrid" data-testid="condition-col">
      <div class="box-content scroller" data-testid="condition-box">
        <h5 class="sticky-top" style="padding-top: 1.2rem; background-color: white" data-testid="condition-title">
          {{ "Conditions" | translate }}
        </h5>
        <div class="row btns-wrapper" data-testid="condition-btns-row">
          <div class="col-xl-4 col-lg-6" *ngFor="let condition of conditions" data-testid="condition-btn-col">
            <div class="btn-col-content" data-testid="condition-btn-content">
              <button class="btn" [class.active]="condition.conditionId === activeCondition" id="condBtn"
                [disabled]="showConditions" style="font-size: 0.9rem"
                (click)="selectedCondition(condition.conditionId, condition)" data-testid="condition-btn">
                {{ condition.conditionDescr }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col quality-select" data-testid="quality-col">
      <!-- Quality box-->
      <div class="box-content" *ngIf="!isPricetype" style="overflow: hidden" data-testid="quality-box">
        <div class="quality-box" data-testid="quality-box-inner">
          <div class="sticky-top header pt-0" style="background-color: #175f91" data-testid="quality-header">
            <h5 class="mb-0" data-testid="quality-title">
              {{ "Quality_Print_Price" | translate }}
            </h5>
          </div>
          <div class="row btns-wrapper" data-testid="quality-btns-row">
            <div class="col-sm price-btns" *ngFor="let button of priceTags" data-testid="quality-btn-col">
              <div class="btn-col-content" data-testid="quality-btn-content">
                <button class="btn" [class.active]="button.qualityId === activeQuality"
                  (click)="activePriceTag(button.qualityID, button)" (keydown.enter)="$event.preventDefault()"
                  [disabled]="showQualityBox" data-testid="quality-btn">
                  <h6 data-testid="quality-btn-label">
                    {{ button.qualityDescr }}
                  </h6>
                  <ng-template [ngxPermissionsOnly]="['Pricing:ViewPricing']">
                    <span data-testid="quality-btn-price">{{
                      button.price | currency
                      }}</span>
                  </ng-template>
                </button>
              </div>
            </div>
          </div>
        </div>
        <ng-template [ngxPermissionsOnly]="['Pricing:OverridePricing']">
          <div class="other-price mt-3" data-testid="other-price-box">
            <h6 data-testid="other-price-title">
              {{ "Other_Price" | translate }}
            </h6>
            <div class="mt-2" data-testid="other-price-form-wrapper">
              <form (ngSubmit)="
                  onSubmit(priceInput.value); priceInput.value = inputValue
                " (keydown.enter)="$event.preventDefault()" class="d-flex align-items-center justify-content-between"
                data-testid="other-price-form">
                <div class="price-input ps-3" data-testid="other-price-input-wrapper">
                  $<input #priceInput type="text" placeholder="{{ 'Enter Amt' | translate }}" class="ms-2" name="price"
                    [(ngModel)]="inputVal" (keyup)="checkPriceNotEmpty()" (blur)="onPriceBlur(priceInput)"
                    [disabled]="activeTag == 0" data-testid="other-price-input" />
                </div>
                <button type="submit" class="btn" [disabled]="showSubmit" data-testid="other-price-submit-btn">
                  {{ "Submit" | translate }}
                </button>
              </form>
            </div>
          </div>
        </ng-template>
        <ng-template [ngxPermissionsExcept]="['Pricing:OverridePricing']">
          <div class="other-price mt-3 w-100" id="disabledOtherPrice" data-testid="other-price-disabled-box">
            <h6 data-testid="other-price-disabled-title">
              {{ "Other_Price" | translate }}
            </h6>
            <div class="mt-2 d-flex align-items-center" data-testid="other-price-disabled-content">
              <span class="p-2 w-50" style="border: 1px solid #918c8c; border-radius: 8px 0 0 8px"
                data-testid="other-price-disabled-input">$ Enter Amt</span>
              <button type="submit" class="btn" data-testid="other-price-disabled-submit-btn">
                {{ "Submit" | translate }}
              </button>
            </div>
          </div>
        </ng-template>
      </div>
      <!-- Price tag box-->
      <div class="box-content" *ngIf="isPricetype" style="overflow: hidden" data-testid="price-tag-box">
        <div class="quality-box" data-testid="price-tag-box-inner">
          <div class="sticky-top header pt-0" style="background-color: #175f91" data-testid="price-tag-header">
            <h5 class="mb-0" data-testid="price-tag-title">
              {{ "Pricing List" | translate }}
            </h5>
            <button class="bg-transparent view-btn border-0" data-bs-target="#viewPricesModal" data-bs-toggle="modal"
              [hidden]="showMorePriceTags" [disabled]="showPrices" data-testid="view-all-prices-btn">
              View All
            </button>
          </div>
          <div class="row btns-wrapper" data-testid="price-tag-btns-row">
            <div class="price-btns" *ngFor="let button of priceTags" data-testid="price-tag-btn-col">
              <div class="btn-col-content" data-testid="price-tag-btn-content">
                <button class="btn" [class.active]="
                    button.priceId === activeQuality && activeTag > 0
                  " (click)="activePriceTag(button.priceId, button)" (keydown.enter)="$event.preventDefault()"
                  [disabled]="showPrices" data-testid="price-tag-btn">
                  <span data-testid="price-tag-btn-price">{{
                    button.price | currency
                    }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <ng-template [ngxPermissionsOnly]="['Pricing:OverridePricing']">
          <div class="other-price mt-3" data-testid="other-price-box-pricetype">
            <h6 data-testid="other-price-title-pricetype">
              {{ "Other_Price" | translate }}
            </h6>
            <div class="d-flex align-items-center justify-content-between mt-2"
              data-testid="other-price-form-wrapper-pricetype">
              <form (ngSubmit)="
                  onSubmit(priceInput.value); priceInput.value = inputValue
                " (keydown.enter)="$event.preventDefault()" class="d-flex align-items-center justify-content-between"
                data-testid="other-price-form-pricetype">
                <div class="price-input ps-3" data-testid="other-price-input-wrapper-pricetype">
                  $<input #priceInput type="text" placeholder="{{ 'Enter_Amt' | translate }}" class="ms-2" name="price"
                    [(ngModel)]="inputVal" (keyup)="checkPriceNotEmpty()" (blur)="onPriceBlur(priceInput)"
                    data-testid="other-price-input-pricetype" />
                </div>
                <button type="submit" class="btn" [disabled]="showSubmit"
                  data-testid="other-price-submit-btn-pricetype">
                  {{ "SUBMIT" | translate }}
                </button>
              </form>
            </div>
          </div>
        </ng-template>
        <ng-template [ngxPermissionsExcept]="['Pricing:OverridePricing']">
          <div class="other-price mt-3 w-100" id="disabledOtherPrice" data-testid="other-price-disabled-box-pricetype">
            <h6 data-testid="other-price-disabled-title-pricetype">
              {{ "Other_Price" | translate }}
            </h6>
            <div class="mt-2 d-flex align-items-center" data-testid="other-price-disabled-content-pricetype">
              <span class="p-2 w-50" style="border: 1px solid #918c8c; border-radius: 8px 0 0 8px"
                data-testid="other-price-disabled-input-pricetype">$ Enter Amt</span>
              <button type="submit" class="btn" data-testid="other-price-disabled-submit-btn-pricetype">
                {{ "Submit" | translate }}
              </button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
<!-- Modals and hidden buttons below (add data-testid as needed for testing) -->
<button style="display: none" #myButton data-bs-toggle="modal" href="#spBrand" data-testid="spbrand-modal-btn">
  btn
</button>
<!-- Hidden trigger to open Print Preview modal via code -->
<button style="display: none" #tagButton data-bs-toggle="modal" href="#exampleModalCenter"
  data-testid="tag-modal-btn">btn</button>
<div #myButton class="modal fade" id="spBrand" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
  tabindex="-1" data-testid="spbrand-modal">
  <div class="custom-modal-dialog modal-dialog modal-dialog-centered" data-testid="spbrand-modal-dialog">
    <div class="modal-content" data-testid="spbrand-modal-content">
      <div class="custom-modal-header modal-header" data-testid="spbrand-modal-header">
        <h5 class="modal-title" id="exampleModalToggleLabel" data-testid="spbrand-modal-title">
          Move to {{ activeBin }} Bin
        </h5>
      </div>
      <div class="custom-modal-body modal-body" data-testid="spbrand-modal-body">
        <div class="modal-body-wraapper" data-testid="spbrand-modal-body-wrapper">
          <p data-testid="spbrand-modal-body-text">
            "This item is intended for sale on the {{ activeBin }} platform."
          </p>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer" data-testid="spbrand-modal-footer">
        <button class="btn modal-btn" data-bs-target="#exampleModalToggle2" data-bs-toggle="modal"
          data-testid="spbrand-modal-override-btn">
          Over-ride
        </button>
        <button class="btn modal-btn" data-bs-target="#exampleModalToggle2" data-bs-toggle="modal" style="
            background-color: rgb(23, 95, 145);
            color: white;
            white-space: nowrap;
          " (click)="moveBin()" (keydown.enter)="$event.preventDefault()" data-testid="spbrand-modal-move-btn">
          Move to Bin
        </button>
      </div>
    </div>
  </div>
</div>
<button style="display: none" #checkBtn data-bs-toggle="modal" href="#checkPrice" data-testid="checkprice-modal-btn">
  btn
</button>
<div class="modal fade" id="checkPrice" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1"
  data-testid="checkprice-modal">
  <div class="custom-modal-dialog modal-dialog modal-dialog-centered" data-testid="checkprice-modal-dialog">
    <div class="modal-content pricemodal" data-testid="checkprice-modal-content">
      <div class="custom-modal-body modal-body pricemodal-body" data-testid="checkprice-modal-body">
        <div class="modal-body-wraapper" data-testid="checkprice-modal-body-wrapper">
          <h5 style="font-size: 1.5rem" data-testid="checkprice-modal-title">
            Price For {{ modalDesc }} -
            {{ this.ctg || this.originalCtgName }} Not Configured
          </h5>
          <p style="font-size: 1.2rem" data-testid="checkprice-modal-text">
            "Contact Store manager or Administrator!"
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="viewSizesModal" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1"
  data-testid="viewsizes-modal">
  <div class="modal-dialog modal-dialog-centered" data-testid="viewsizes-modal-dialog">
    <div class="modal-content" data-testid="viewsizes-modal-content">
      <div class="custom-modal-header modal-header" style="padding: 1.3rem 1.8rem 0.5rem 1.7rem"
        data-testid="viewsizes-modal-header">
        <h5 class="mb-0" data-testid="viewsizes-modal-title">
          {{ "Size" | translate }}
        </h5>
        <button type="button" class="close bg-transparent border-0" data-bs-dismiss="modal" aria-bs-label="Close"
          data-testid="viewsizes-modal-close-btn">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="custom-modal-body modal-body pb-4 pt-2" data-testid="viewsizes-modal-body">
        <div class="modal-body-wraapper w-100" data-testid="viewsizes-modal-body-wrapper">
          <div *ngFor="let button of sizeButtons; let i = index" data-testid="viewsizes-modal-size-btn-row">
            <button class="btn size-btn close" [class.active]="button.sizeId === activeButtonIndex"
              data-bs-dismiss="modal" aria-bs-label="Close"
              (click)="activeSizeButton(button.sizeId, button.alphaSize, i)" data-testid="viewsizes-modal-size-btn">
              {{ button.alphaSize }}<br />
              <span class="ansize text-nowrap" data-testid="viewsizes-modal-size-range">
                {{ button.numericSizeRange }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="viewPricesModal" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1"
  data-testid="viewprices-modal">
  <div class="modal-dialog modal-dialog-centered" data-testid="viewprices-modal-dialog">
    <div class="modal-content" style="background-color: #175f91" data-testid="viewprices-modal-content">
      <div class="custom-modal-header modal-header" style="padding: 1.3rem 1.8rem 0.5rem 1.7rem"
        data-testid="viewprices-modal-header">
        <h5 class="mb-0" data-testid="viewprices-modal-title">
          {{ "Pricing List" | translate }}
        </h5>
        <button type="button" class="close bg-transparent border-0" data-bs-dismiss="modal" aria-bs-label="Close"
          #priceTagBtn data-testid="viewprices-modal-close-btn">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="custom-modal-body modal-body pb-4 pt-2" data-testid="viewprices-modal-body">
        <div class="modal-body-wraapper w-100" data-testid="viewprices-modal-body-wrapper">
          <div *ngFor="let button of priceTags" data-testid="viewprices-modal-price-btn-row">
            <button class="btn size-btn close" [class.active]="button.PriceID === activeQuality && activeTag > 0"
              (click)="activePriceTag(button.PriceID, button)" (keydown.enter)="$event.preventDefault()"
              [disabled]="showPrices" data-testid="viewprices-modal-price-btn">
              <span data-testid="viewprices-modal-price">{{ button.Price | currency }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true" data-testid="printpreview-modal">
  <div class="modal-dialog modal-dialog-centered" role="document" data-testid="printpreview-modal-dialog">
    <div class="modal-content" data-testid="printpreview-modal-content">
      <div class="modal-header justify-content-between align-items-center" data-testid="printpreview-modal_header">
        <h4 style="margin: 0" data-testid="printpreview-modal-title">
          Print Preview
        </h4>
        <button type="button" class="close-tag" data-bs-dismiss="modal" aria-label="Close" #closeBtn
          data-testid="printpreview-modal-close-btn">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" data-testid="printpreview-modal-body">
        <div id="container" data-testid="printpreview-modal-container"></div>
        <img 
          *ngIf="labelImg && labelImg.toString().length > 0"
          [src]="labelImg" 
          class="previewImg" 
          data-testid="printpreview-modal-img" 
        />
        <p
          *ngIf="!labelImg || labelImg.toString().length === 0"
          class="invalidMsg"
        >
          Invalid ZPL Code
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Button trigger modal -->
<button style="display: none" #productionLimitBtn data-bs-toggle="modal" href="#ProductionLimit">
  btn
</button>

<!-- Production Limit  -->
<div class="modal fade" id="ProductionLimit" tabindex="-1" role="dialog" aria-labelledby="ProductionLimit"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="modal-body-wraapper w-100 text-center">
          <h5 style="font-size: 1.5rem;">
            {{productionLimitPopupMsg}}
          </h5>
        </div>
      </div>
      <div class="modal-footer justify-content-center">
        <div>
          <button class="btn btn-secondary px-4" (click)="validateProductionLimit(false)" data-bs-dismiss="modal">
            Cancel
          </button>
        </div>
        <div>
          <button class="btn confirm-btn px-4" (click)="validateProductionLimit(true)" data-bs-dismiss="modal">
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Button trigger modal -->
<button style="display: none" #productionLimitBtn data-bs-toggle="modal" href="#ProductionLimit">
  btn
</button>

<!-- Production Limit  -->
<div class="modal fade" id="ProductionLimit" tabindex="-1" role="dialog" aria-labelledby="ProductionLimit"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="modal-body-wraapper w-100 text-center">
          <h5 style="font-size: 1.5rem;">
            {{productionLimitPopupMsg}}
          </h5>
        </div>
      </div>
      <div class="modal-footer justify-content-center">
        <div>
          <button class="btn btn-secondary px-4" (click)="validateProductionLimit(false)" data-bs-dismiss="modal">
            Cancel
          </button>
        </div>
        <div>
          <button class="btn confirm-btn px-4" (click)="validateProductionLimit(true)" data-bs-dismiss="modal">
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>
</div>